// Pop-up: generate / preview / email customer statements for the period (with standing CC).
// Part of the Balances page (components/Balances.jsx). Split out 2026-10-14.
import { fmtCycleLabel } from './helpers.js';
import { postJson, fetchJson } from '../../api.js';

export default function StatementsModal({ canWrite, customers, cycleKey, from, openStatementsModal, saveStmtCc, setStmtCc, setStmtsBusy, setStmtsOpen, stmtCc, stmtCcBusy, stmtCcSaved, stmtRange, stmtsBusy, stmtsList, stmtsOpen, to }) {
  return (
    <>
      {stmtsOpen && (
        <div className="modal-backdrop" onClick={() => !stmtsBusy && setStmtsOpen(false)}>
          <div className="modal-card" onClick={e => e.stopPropagation()} style={{ minWidth: 640, maxWidth: 880, maxHeight: '85vh', overflowY: 'auto' }}>
            <h3 style={{ marginTop: 0 }}>📄 Generate statements — {fmtCycleLabel(cycleKey)}</h3>
            <p className="small" style={{ marginTop: 0, color: '#666' }}>
              Each row is a separate per-customer PDF. The SUMMARY row at the top is the company-wide rollup. Click any link to download the PDF in a new tab.
              Emailing comes from the Send statements workflow (separate button after review).
            </p>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', margin: '0.25rem 0 0.75rem', padding: '0.45rem 0.6rem', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 6 }}>
              <span className="small" style={{ whiteSpace: 'nowrap', fontWeight: 600 }} title="These addresses are CC'd on EVERY statement email (live sends). Ops copies, etc. Comma-separated.">
                CC on every statement:
              </span>
              <input value={stmtCc} onChange={e => setStmtCc(e.target.value)}
                     placeholder="ops@ecovac.ca (comma-separated, blank = none)"
                     style={{ flex: 1, fontSize: '0.85em', padding: '0.25rem 0.4rem' }} />
              <button className="refresh-btn small" onClick={saveStmtCc}
                      disabled={stmtCcBusy || stmtCc.trim() === stmtCcSaved.trim()}
                      style={{ background: '#0e7490' }}>
                {stmtCcBusy ? 'Saving…' : (stmtCc.trim() === stmtCcSaved.trim() ? 'Saved' : 'Save CC')}
              </button>
            </div>
            {stmtsBusy && <div>Loading customer list…</div>}
            {stmtsList && stmtsList.error && <div className="small" style={{ color: '#991b1b' }}>{stmtsList.error}</div>}
            {stmtsList && !stmtsList.error && stmtsList.pendingSendCount > 0 && (
              <div style={{ background: '#fff4e5', border: '1px solid #f59e0b', borderRadius: 6, padding: '0.55rem 0.75rem', margin: '0.25rem 0 0.75rem', fontSize: '0.9em', color: '#78350f' }}>
                <strong>⚠ {stmtsList.pendingSendCount} customer{stmtsList.pendingSendCount === 1 ? '' : 's'} blocked from Send:</strong>{' '}
                pending Google-form items awaiting operator approval. Statements still generate for review; the send button is hidden until the inbox is cleared.
              </div>
            )}
            {stmtsList && !stmtsList.error && (
              <table className="fs-table tidy" style={{ fontSize: '0.9em' }}>
                <thead><tr><th>Customer</th><th className="num">Loads</th><th className="num" title="Google-form rows awaiting approval — blocks Send">Pending</th><th>Statement PDF</th><th title="Whether a statement has been emailed for this cycle already">Sent</th></tr></thead>
                <tbody>
                  <tr style={{ background: '#f0f9ff', fontWeight: 600 }}>
                    <td>SUMMARY (all customers)</td>
                    <td className="num">{stmtsList.customers.reduce((s, c) => s + c.count, 0)}</td>
                    <td className="num" style={{ color: stmtsList.pendingSendCount > 0 ? '#c05100' : '#94a3b8' }}>
                      {stmtsList.customers.reduce((s, c) => s + (c.pendingCount || 0), 0) || '—'}
                    </td>
                    <td><a href={'/api/statements/generate?' + stmtRange + '&summary=1'} target="_blank" rel="noreferrer">📄 SUMMARY_{stmtsList.bounds && stmtsList.bounds.end}.pdf</a></td>
                    <td className="small" style={{ color:'#666' }}>—</td>
                  </tr>
                  {stmtsList.customers.map(c => (
                    <tr key={c.customer} style={c.sendBlocked ? { background: '#fffbeb' } : undefined}>
                      <td>{c.customer}</td>
                      <td className="num">{c.count}</td>
                      <td className="num" title={c.sendBlocked ? c.pendingCount + ' pending Google-form row(s) — Send blocked' : ''}
                          style={c.sendBlocked ? { color: '#c05100', fontWeight: 600 } : { color: '#94a3b8' }}>
                        {c.pendingCount ? c.pendingCount : '—'}
                      </td>
                      <td>
                        <a href={'/api/statements/generate?' + stmtRange + '&customer=' + encodeURIComponent(c.customer)} target="_blank" rel="noreferrer">📄 statement</a>
                        {c.wantsExcel && (
                          <>
                            {' '}
                            <a href={'/api/statements/generate?' + stmtRange + '&customer=' + encodeURIComponent(c.customer) + '&format=xlsx'} target="_blank" rel="noreferrer" style={{ marginLeft: '0.4rem' }}>📎 xlsx</a>
                          </>
                        )}
                        {canWrite && c.sendBlocked && (
                          <span style={{ marginLeft: '0.5rem', color: '#c05100', fontSize: '0.85em' }}
                                title="Approve the pending Google-form rows in the Tips inbox before sending.">
                            ⏸ waiting on reconciliation
                          </span>
                        )}
                        {canWrite && !c.sendBlocked && (
                          <button className="link" style={{ marginLeft: '0.5rem', color: '#0369a1' }}
                            disabled={stmtsBusy}
                            onClick={async () => {
                              if (c.lastSentAt && !confirm('Statement already sent to ' + c.customer + ' on ' + String(c.lastSentAt).slice(0,10) + '. Send again?')) return;
                              if (!c.lastSentAt && !confirm('Send statement for ' + c.customer + ' to their contact email(s)?')) return;
                              setStmtsBusy(true);
                              try {
                                const r = await postJson('/api/statements/send', { cycle_key: cycleKey, dryRun: false, customers: [c.customer] });
                                alert('Send complete for ' + c.customer + ':\n· ' + (r.sentCount || 0) + ' sent\n· ' + (r.failedCount || 0) + ' failed\n· ' + (r.skipped || 0) + ' skipped (no contacts)');
                                openStatementsModal();
                              } catch (e) { alert('Send failed: ' + e.message); }
                              finally { setStmtsBusy(false); }
                            }}>
                            📧 send
                          </button>
                        )}
                      </td>
                      <td className="small">
                        {c.lastSentAt ? (
                          <span title={'Sent by ' + (c.lastSentBy || 'unknown') + ' on ' + String(c.lastSentAt).slice(0,19).replace('T',' ')
                                       + '\n\nTo: ' + ((c.lastSentTo || []).join(', ') || '(none recorded)')
                                       + ((c.lastSentCc || []).length ? '\nCc: ' + c.lastSentCc.join(', ') : '')}
                                style={{ color:'#15803d', cursor:'help' }}>
                            ☑ <span style={{ fontSize:'0.85em' }}>{String(c.lastSentAt).slice(0,10)}
                            {' → '}{(c.lastSentTo || []).length + (c.lastSentCc || []).length} recip.</span>
                          </span>
                        ) : (
                          <span style={{ color:'#94a3b8' }} title="No live send recorded for this cycle">☐ not sent</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
              {canWrite && stmtsList && stmtsList.customers && (
                <>
                  {(() => {
                    // Bulk send only targets customers that AREN'T blocked
                    // by pending items. Reconciliation clears the pending
                    // rows, then the same button can be used to catch them.
                    const sendable = stmtsList.customers.filter(c => !c.sendBlocked);
                    const blocked = stmtsList.customers.length - sendable.length;
                    const blockedNote = blocked ? ('\n\n' + blocked + ' customer(s) skipped: pending items awaiting reconciliation.') : '';
                    return (
                      <>
                        <button className="refresh-btn" disabled={stmtsBusy || sendable.length === 0} style={{ background: '#7c3aed' }}
                          onClick={async () => {
                            if (!confirm('Send statements (DRY RUN) for ' + sendable.length + ' customer(s)?' + blockedNote + '\n\nDry-run logs who would receive what, but does NOT actually email. Use this first to verify the contact lists.')) return;
                            setStmtsBusy(true);
                            try {
                              const r = await postJson('/api/statements/send', { cycle_key: cycleKey, dryRun: true, customers: sendable.map(c => c.customer) });
                              alert('Dry-run complete:\n· ' + r.sentCount + ' would send\n· ' + r.failedCount + ' would fail\n· ' + r.skipped + ' skipped (no contacts)\n\nSMTP configured: ' + (r.smtpConfigured ? 'yes' : 'NO — set SMTP_HOST in Azure SWA Configuration to enable real sending'));
                            } catch (e) { alert('Dry-run failed: ' + e.message); }
                            finally { setStmtsBusy(false); }
                          }}>
                          🧪 Send (dry-run){blocked ? ' — ' + sendable.length + '/' + stmtsList.customers.length : ''}
                        </button>
                        <button className="refresh-btn" disabled={stmtsBusy || sendable.length === 0} style={{ background: '#b91c1c' }}
                          onClick={async () => {
                            if (!confirm('SEND statements LIVE to ' + sendable.length + ' customer(s)?' + blockedNote + '\n\nEach customer\'s PDF goes to every contact in customer_contacts. There is no undo. Audit trail captures every send.')) return;
                            setStmtsBusy(true);
                            try {
                              const r = await postJson('/api/statements/send', { cycle_key: cycleKey, dryRun: false, customers: sendable.map(c => c.customer) });
                              alert('Send complete:\n· ' + r.sentCount + ' sent\n· ' + r.failedCount + ' failed\n· ' + r.skipped + ' skipped (no contacts)\n\nSee Audit log for per-recipient detail.');
                              openStatementsModal();
                            } catch (e) { alert('Send failed: ' + e.message); }
                            finally { setStmtsBusy(false); }
                          }}>
                          📧 Send LIVE{blocked ? ' — ' + sendable.length + '/' + stmtsList.customers.length : ' to all customers'}
                        </button>
                        <button className="refresh-btn" disabled={stmtsBusy} style={{ background: '#0e7490' }}
                          title="Statements no longer auto-email certificates — send them separately here when ready."
                          onClick={async () => {
                            setStmtsBusy(true);
                            try {
                              const lst = await fetchJson('/api/compliance-certificates?cycle_key=' + encodeURIComponent(cycleKey) + '&limit=500');
                              const certs = lst.certificates || lst.rows || [];
                              if (certs.length === 0) {
                                alert('No certificates exist yet for cycle ' + fmtCycleLabel(cycleKey) + '.\n\nCertificates are prepared when statements are sent (or via Generate on the Compliance certificates subtab).');
                                return;
                              }
                              const neverSent = certs.filter(c => !c.sent_at).length;
                              if (!confirm('⚠️ SEND CERTIFICATES — please read\n\nThis will EMAIL ' + certs.length + ' compliance certificate(s) for cycle ' + fmtCycleLabel(cycleKey) + ' to each customer’s certificate recipients.\n\n' + (neverSent ? neverSent + ' have never been sent; the rest will be RE-SENT.\n\n' : '') + 'Customers with no certificate recipients are skipped and reported.\n\nSend now?')) return;
                              // Chunked: one big request risks the gateway timeout
                              // + Graph rate limits (the "26 failed" incident).
                              const tot = { sent: 0, skipped: 0, failed: 0 };
                              const allIds = certs.map(c => c.id);
                              for (let i = 0; i < allIds.length; i += 8) {
                                const r = await postJson('/api/compliance-certificates/send-bulk', { certIds: allIds.slice(i, i + 8) });
                                tot.sent += r.sent ?? 0; tot.skipped += r.skippedNoRecipients ?? 0; tot.failed += r.failed ?? 0;
                              }
                              alert('Certificate send complete:\n· ' + tot.sent + ' sent\n· ' + tot.skipped + ' skipped (no recipients)\n· ' + tot.failed + ' failed\n\nDetail is on the Compliance certificates subtab + audit log.');
                            } catch (e) { alert('Certificate send failed: ' + e.message); }
                            finally { setStmtsBusy(false); }
                          }}>
                          🛡 Send certificates
                        </button>
                      </>
                    );
                  })()}
                </>
              )}
              <button className="refresh-btn" onClick={() => setStmtsOpen(false)} style={{ background: '#888' }}>Close</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
